<template>
  <v-tooltip v-if="value" top>
    <template v-slot:activator="{ on }">
      <div
        v-on="on"
        class="lh-1 d-flex flex-column justify-center"
        style="height: 100%; min-height: 40px; cursor: help"
      >
        {{ [value] | dateDiff(true) }}
      </div>
    </template>
    <span>{{ value | date("DD/MM/YY HH:mm:ss") }}</span>
  </v-tooltip>
  <span v-else class="text--disabled">—</span>
</template>

<script>
export default {
  name: "DateCell",
  props: {
    value: {
      type: [String, Date],
      default: null,
    },
  },
};
</script>
